// @TODO: <HEALTH2019>
App.filter('dateFormatterTime', function () {
    return function (miliSec, defaultTimezone) {
        miliSec = miliSec || '';
        if (miliSec) {
            var time = new Date(miliSec);

            if (defaultTimezone) {
                var day = time.getDate();
                var month = time.getMonth() + 1;
                var year = time.getFullYear();
                var hours = time.getHours();
                var minutes = time.getMinutes();
            } else {
                var day = time.getUTCDate();
                var month = time.getUTCMonth() + 1;
                var year = time.getUTCFullYear();
                var hours = time.getUTCHours();
                var minutes = time.getUTCMinutes();
            }

            if (day < 10) day = '0' + day;
            if (month < 10) month = '0' + month;
            if (hours < 10) hours = '0' + hours;
            if (minutes < 10) minutes = '0' + minutes;

            var all = day + '.' + month + '.' + year + ' ' + hours + ':' + minutes;
        }
        return all;
    };
});
// @TODO: </HEALTH2019>
